import * as React from "react";
import { Home } from "./components/Home";
import AuthPage from "./components/Auth";
import { ToastProvider } from "@heroui/react";
import useAuthStore from "./store/authStore";

const App: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <div>
      <ToastProvider placement="top-left" />
      {isAuthenticated ? <Home /> : <AuthPage />}
    </div>
  );
};

export default App;
